
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[franchise]/[slug]",
      function () {
        return require("private-next-pages/insights/[franchise]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[franchise]/[slug]"])
      });
    }
  